/* CARRITO — el cajon de la derecha, calcado del de Huel.

   Por que se dibuja en el navegador y no con Liquid: el carrito cambia sin que
   la pagina se recargue (sumar, restar, borrar, agregar un sugerido). Pidiendo
   /cart.js despues de cada cambio, el cajon siempre muestra lo que el servidor
   dice que hay, sin tener que re-renderizar secciones ni mantener dos copias
   del estado.

   El icono del header sigue siendo un <a href="/cart"> de verdad: solo se le
   intercepta el click. Sin JS, el carrito de siempre sigue funcionando. */
(function(){
  var cfg = window.RZ_CART || {};
  var caja = document.getElementById('rz-cart');
  if(!caja) return;
  var cuerpo = caja.querySelector('[data-rz-cart-cuerpo]');
  var pie    = caja.querySelector('[data-rz-cart-pie]');
  var totalF = caja.querySelector('[data-rz-cart-total]');
  var trabajando = false;
  var yScroll = 0;

  /* ---------- plata ---------- */
  /* El formato de la tienda es ${{amount_with_comma_separator}}: miles con
     punto y decimales con coma. Los precios de /cart.js vienen en centavos. */
  function plata(centavos){
    var n = Math.round(centavos)/100;
    var ent = Math.floor(n);
    var dec = Math.round((n-ent)*100);
    var s = String(ent).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return '$' + s + (dec ? ',' + (dec<10?'0':'') + dec : '');
  }
  function esc(t){
    return String(t==null?'':t).replace(/[&<>"']/g, function(c){
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];
    });
  }

  /* ---------- abrir y cerrar ---------- */
  function abrir(){
    yScroll = window.scrollY;
    caja.classList.add('is-open');
    caja.setAttribute('aria-hidden','false');
    document.body.style.position='fixed';
    document.body.style.top=(-yScroll)+'px';
    document.body.style.width='100%';
    cargar();
  }
  /* Puerta de entrada para otras secciones: el quiz agrega al carrito por su
     cuenta y despues necesita abrir el cajon. Sin esto tendria que simular un
     click en el icono, que es fragil. */
  window.RZ_CART_ABRIR = abrir;

  function cerrar(){
    caja.classList.remove('is-open');
    caja.setAttribute('aria-hidden','true');
    document.body.style.position='';
    document.body.style.top='';
    document.body.style.width='';
    window.scrollTo(0,yScroll);
  }
  var cierres = caja.querySelectorAll('[data-rz-cart-cerrar]');
  for(var i=0;i<cierres.length;i++) cierres[i].addEventListener('click',cerrar);
  document.addEventListener('keydown',function(e){
    if(e.key==='Escape' && caja.classList.contains('is-open')) cerrar();
  });

  /* Cualquier link al carrito abre el cajon en vez de irse de la pagina. */
  document.addEventListener('click',function(e){
    var a = e.target.closest && e.target.closest('a[href$="/cart"], a[href*="/cart?"]');
    if(!a) return;
    e.preventDefault();
    abrir();
  });

  /* ---------- cuantos acondicionadores quiere ----------
     El selector del renglon del regalo fija el TOTAL. Shopify ya sabe cuantos
     van gratis: MEDIDO contra el carrito real, pidiendo 5 devuelve "3 en $0 y
     2 en $51.980", pidiendo 8 devuelve "3 en $0 y 5 en $129.950". O sea que
     los de mas SE COBRAN, que es justo lo que se queria: el que ya tiene 3 de
     regalo puede llevarse 3 mas pagandolos.

     Se manda en UNA sola llamada: la primera linea de regalo al total nuevo y
     las demas a cero. Si no, el reparto viejo se suma al nuevo. */
  function cambiarRegalo(total, linea){
    if(trabajando) return;
    trabajando = true;
    /* El mismo apagado con spinner que cuando se cambia el shampoo: sin esto
       el renglon del acondicionador se quedaba quieto y el cambio aparecia de
       golpe. Mark lo vio en el video. */
    if(linea) ocupar(linea);
    return fetch('/cart.js',{headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); })
      .then(function(c){
        var upd = {}, primera = true;
        for(var i=0;i<c.items.length;i++){
          if(!esRegaloKaching(c.items[i])) continue;
          upd[c.items[i].key] = primera ? total : 0;
          primera = false;
        }
        if(primera){ trabajando = false; return; }
        return fetch('/cart/update.js',{method:'POST',
            headers:{'Content-Type':'application/json'},body:JSON.stringify({updates:upd})})
          .then(function(){ return pedir(); })
          .then(function(c2){ trabajando = false; pintar(c2); avisar(c2); });
      })
      .catch(function(){ trabajando = false; cargar(); });
  }

  /* ---------- sacar el cupon ----------
     Hacen falta LAS DOS cosas y en este orden. Medido contra el checkout:
       · solo `discount:''`  → saca el del porcentaje y DEJA el de envio
       · solo borrar la cookie → no saca ninguno: la cookie lo vuelve a aplicar
       · las dos             → el checkout queda sin ningun codigo
     Por eso la cruz saca el juego completo y no un cupon suelto: en la sesion
     de Shopify es uno solo. */
  function quitarCupon(){
    return fetch('/cart/update.js', {method:'POST',
        headers:{'Content-Type':'application/json'},
        body: JSON.stringify({discount:''})})
      .then(function(){
        var host = location.hostname.replace(/^www\./,'');
        document.cookie = 'discount_code=; Max-Age=0; path=/';
        document.cookie = 'discount_code=; Max-Age=0; path=/; domain=.' + host;
        try{ localStorage.removeItem('rzjg_envio'); }catch(e){}
      })
      .then(cargar)
      .catch(cargar);
  }

  /* ---------- datos ---------- */
  function pedir(){
    return fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){ return r.json(); });
  }
  function cargar(){
    /* avisar() tambien va aca. Antes solo corria al cambiar una cantidad o al
       agregar un sugerido, asi que la chapita del header quedaba en cero aunque
       hubiera productos: era justo lo que se veia mal. */
    return pedir().then(function(c){ pintar(c); avisar(c); }).catch(function(){
      cuerpo.innerHTML = '<div class="rz-cart__cargando">No pudimos cargar el carrito. Probá de nuevo.</div>';
    });
  }

  /* Al cargar la pagina se consulta el carrito una vez, sin dibujar nada, solo
     para poner la chapita en su numero. Si no, el visitante que vuelve con algo
     adentro ve el icono vacio hasta que abre el cajon. */
  pedir().then(avisar).catch(function(){});

  /* Marca UNA fila como ocupada mientras viaja el pedido, igual que Huel: la
     fila se apaga y le aparece un spinner encima. Lo demas del carrito queda
     usable. */
  function ocupar(linea){
    var f = cuerpo.querySelector('.rz-cart__item[data-linea="'+linea+'"]');
    if(f) f.classList.add('esta-cargando');
    return f;
  }


  /* ══════════════════════════════════════════════════════════════
     LOS REGALOS, CUANDO SE CAMBIA LA CANTIDAD DESDE EL CARRITO

     Kaching engancha los regalos en el momento de agregar al carrito, no
     despues. Si el cliente agrega el pack de 3 y despues sube el selector a 6,
     el precio queda bien —eso lo resuelve el servidor mirando la cantidad—
     pero los tres acondicionadores no aparecen.
     Y al revés era peor: bajando de 6 a 3, los acondicionadores se QUEDABAN en
     el carrito y pasaban a cobrarse. MEDIDO el 21/09: el total saltaba de
     $99.990 a $143.950 por bajar la cantidad. Un cliente podia terminar
     comprando $77.970 de acondicionador sin haberlo pedido.

     Entonces, cada vez que cambia la cantidad del shampoo:
       1. se sacan los regalos que haya
       2. si la cantidad nueva tiene regalo, se agrega
       3. se vuelve a leer el carrito y, SI NO VINO EN $0, se saca

     El paso 3 es el que hace que esto sea seguro. La linea del regalo se arma
     copiando deal, v e id de la linea principal y agregandole el id del
     regalo, que es lo unico escrito a mano. Si Kaching cambia su
     configuracion, el descuento no se aplica, el paso 3 lo detecta y el regalo
     se va: el cliente se queda sin regalo, que es molesto, pero NUNCA pagando
     algo que no pidio. ══════════════════════════════════════════════════════ */

  /* Los regalos ESCALAN con la cantidad: tres acondicionadores desde 6, seis
     desde 12. Antes era una tabla con un solo escalon, el de 6, y por eso el
     que subia a 7 perdia el regalo — "comprando 6 me regalan pero 7 no",
     Mark el 25/09.

     ⚠️ No hizo falta tocar Kaching. MEDIDO contra el carrito real, colgando el
     regalo con el deal de la linea principal: a 7, 8, 9 y 11 los tres
     acondicionadores vienen en $0, y a 12 vienen los SEIS en $0. Si algun dia
     la app deja de reconocerlos, el paso 3 de abajo los saca y el cliente se
     queda sin regalo, nunca pagandolo.

     El tope de 12 es el del selector del carrito: no se ofrece mas. */
  var GIFT_ACOND = { variante: 47280336044281, gift: 'mqc2' };
  function regalosDe(cant){
    if(cant >= 12) return [{ variante: GIFT_ACOND.variante, cantidad: 6, gift: GIFT_ACOND.gift }];
    if(cant >= 6)  return [{ variante: GIFT_ACOND.variante, cantidad: 3, gift: GIFT_ACOND.gift }];
    return null;
  }

  function esRegaloKaching(it){
    try { return /"gift"\s*:/.test((it.properties||{}).__kaching_bundles||''); }
    catch(e){ return false; }
  }
  function sobreKaching(it){
    try { return JSON.parse((it.properties||{}).__kaching_bundles||'null'); }
    catch(e){ return null; }
  }

  function reconciliarRegalos(){
    return fetch('/cart.js',{headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); })
      .then(function(c){
        var principal=null, quitar={};
        for(var i=0;i<c.items.length;i++){
          var it=c.items[i];
          if(esRegaloKaching(it) || esRegaloLanding(it)) quitar[it.key]=0;
          else if(it.variant_id===SHAMPOO_P1) principal=it;
          if(esRegaloLanding(it)) var sacarCodigo = true;
          if(landingRegalo(c)) sacarCodigo = true;
        }
        var paso = Object.keys(quitar).length
          ? fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(sacarCodigo ? {updates:quitar, discount:''} : {updates:quitar})})
          : Promise.resolve();

        return paso.then(function(){
          if(!principal) return;
          var rl = landingRegalo(c) ? regaloLandingDe(principal.quantity) : null;
          if(rl){
            return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:ACOND_ID,quantity:rl[0],properties:{_regalo:'landing cyber-regalo'}}]})})
              .then(function(){ return fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({discount:rl[1]})}); });
          }
          var lista = regalosDe(principal.quantity);
          var sobre = sobreKaching(principal);
          /* Sin los datos de Kaching en la linea principal no se puede armar un
             regalo que su funcion reconozca. Mejor quedarse sin regalo. */
          if(!lista || !sobre || !sobre.deal || !sobre.id) return;
          var items = lista.map(function(g){
            return { id:g.variante, quantity:g.cantidad,
                     properties:{ __kaching_bundles: JSON.stringify(
                       { id:sobre.id, deal:sobre.deal, v:sobre.v, gift:g.gift }) } };
          });
          return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})})
            .then(function(){ return new Promise(function(res){ setTimeout(res,1200); }); })
            .then(function(){ return fetch('/cart.js',{headers:{'Accept':'application/json'}}); })
            .then(function(r){ return r.json(); })
            .then(function(c2){
              /* El chequeo: si el regalo no vino gratis, se saca. */
              var malos={};
              for(var j=0;j<c2.items.length;j++){
                var x=c2.items[j];
                if(esRegaloKaching(x) && x.final_line_price>0) malos[x.key]=0;
              }
              if(!Object.keys(malos).length) return;
              return fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({updates:malos})});
            });
        });
      })
      .then(function(){ return fetch('/cart.js',{headers:{'Accept':'application/json'}}); })
      .then(function(r){ return r.json(); })
      .catch(function(){ return null; });
  }

  function cambiar(linea, cantidad){
    if(trabajando) return;
    trabajando = true;
    var fila = ocupar(linea);
    /* Si la cantidad va a cero, la fila se va con una salida propia —se achica
       y se desvanece— y recien despues se vuelve a dibujar el carrito. Sin eso
       la fila desaparecia de un cuadro al otro. */
    var sale = (cantidad === 0 && fila) ? salir(fila) : Promise.resolve();
    return fetch('/cart/change.js',{
      method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({line: linea, quantity: cantidad})
    }).then(function(r){ return r.json(); }).then(function(c){
      /* Si lo que se movio fue el shampoo, hay que rearmar los regalos: ver el
         comentario largo de reconciliarRegalos. Se dibuja igual con lo que
         devuelva, y si algo falla queda el carrito que ya teniamos. */
      var tocoShampoo = false;
      for(var i=0;i<c.items.length;i++) if(c.items[i].variant_id===SHAMPOO_P1) tocoShampoo = true;
      if(!tocoShampoo && cantidad === 0) tocoShampoo = true;
      var listo = tocoShampoo ? reconciliarRegalos().then(function(c2){ return c2 || c; })
                              : Promise.resolve(c);
      return listo.then(function(cf){
        return sale.then(function(){
          trabajando = false; pintar(cf); avisar(cf);
        });
      });
    }).catch(function(){ trabajando = false; cargar(); });
  }

  /* Salida de una fila: se fija el alto que tiene, se fuerza el reflujo y se
     lleva a cero junto con la opacidad. Es la unica forma de animar un alto
     automatico sin medirlo a mano en CSS. */
  function salir(fila){
    return new Promise(function(res){
      var alto = fila.offsetHeight;
      fila.style.height = alto+'px';
      fila.classList.add('esta-saliendo');
      void fila.offsetHeight;
      fila.style.height = '0px';
      setTimeout(res, 340);
    });
  }

  function sumar(id, boton){
    if(trabajando) return;
    trabajando = true;
    /* Spinner en el boton, no "Agregando…": cambiarle el texto le cambia el
       ancho al boton y toda la tarjeta pega un salto. */
    if(boton){ boton.disabled = true; boton.classList.add('esta-cargando'); }
    var tarjeta = boton && boton.closest ? boton.closest('.rz-cart__sug-item') : null;
    if(tarjeta && tarjeta.animate) tarjeta.animate([{opacity:1},{opacity:.55}], { duration:260, easing:'ease-out', fill:'forwards' });
    return fetch('/cart/add.js',{
      method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({items:[{id:id, quantity:1}]})
    }).then(function(){ return pedir(); }).then(function(c){
      trabajando = false; pintar(c); avisar(c);
    }).catch(function(){ trabajando = false; cargar(); });
  }

  /* El contador del header se actualiza solo, sin recargar.
     OJO: la actualizacion NO va aca adentro sino colgada del evento. El quiz
     tambien agrega al carrito por su cuenta y avisa con el mismo evento; cuando
     esto vivia dentro de avisar(), agregar desde el quiz dejaba la chapita del
     header en cero. Colgado del evento, se actualiza venga de donde venga. */
  function avisar(c){
    document.dispatchEvent(new CustomEvent('rz:carrito', {detail:c}));
  }

  /* ---------- pintar ---------- */
  /* PACKS (Mark 11/10): el tachado del renglón sale del PRECIO DE COMPARACIÓN que se carga en Shopify.
     /cart.js no trae el compare_at, así que la primera vez que aparece un pack se pide su producto
     (/products/HANDLE.js) y se guarda por variante. Si se cambia el precio de comparación en el admin,
     el carrito lo toma solo. Solo para handles que empiezan con "pack-"; el shampoo sigue con su tabla fija. */
  var COMPARA = {};
  function precargar(c){
    var faltan = {};
    (c && c.items || []).forEach(function(it){
      if(it.handle && it.handle.indexOf('pack-') === 0 && !(it.variant_id in COMPARA)) faltan[it.handle] = 1;
    });
    var hs = Object.keys(faltan);
    if(!hs.length) return Promise.resolve();
    return Promise.all(hs.map(function(h){
      return fetch('/products/'+h+'.js').then(function(r){ return r.json(); }).then(function(p){
        (p.variants||[]).forEach(function(v){ COMPARA[v.id] = v.compare_at_price || 0; });
      }).catch(function(){});
    }));
  }
  function pintar(c){ return precargar(c).then(function(){ pintarYa(c); }); }

  function pintarYa(c){
    if(!c.items || !c.items.length){ vacio(); return; }
    var h = '';

    /* ⚠️ LA BARRA MIDE CONTRA EL SUBTOTAL, NO CONTRA EL TOTAL. Shopify evalua
       el minimo de un descuento automatico sobre el subtotal de las lineas,
       antes de aplicar el descuento. Midiendo el total pasaba esto: con 8
       unidades el subtotal da $133.320, se gana el 10%, el total baja a
       $119.988 y la barra volvia a decir "sumá $12 más y te llevás 10% off"
       mientras el resumen ya mostraba el 10% aplicado. */
    var base = c.items_subtotal_price;
    if(!base){ base = 0; for(var bb=0;bb<c.items.length;bb++) base += c.items[bb].final_line_price; }
    for(var bg=0;bg<c.items.length;bg++) if(esRegaloLanding(c.items[bg])) base -= c.items[bg].final_line_price;
    h += barraEnvio(base);

    /* EL ORDEN NO ES EL DEL CARRITO SINO POR TIPO DE PRODUCTO: shampoo,
       acondicionador y masajeador. Se ordena una COPIA que se guarda el numero
       de linea original, porque ese numero es el que entiende /cart/change.js:
       si ordenara los items y usara la posicion nueva, tocarle la cantidad a uno
       se la cambiaria a otro. */
    var RANGO = { 'raizal-shampoo':1, 'raizal-acondicionador-activador-de-raices':2,
                  'masajeador-capilar-de-regalo':3 };
    var filas = [];
    for(var k=0;k<c.items.length;k++) filas.push({ it:c.items[k], linea:k+1 });
    filas.sort(function(a,b){
      var ra = RANGO[a.it.handle] || 9, rb = RANGO[b.it.handle] || 9;
      return ra !== rb ? ra - rb : a.linea - b.linea;
    });

    /* LAS LINEAS DE REGALO SE DIBUJAN COMO UNA SOLA. Cuando el cliente pide
       mas acondicionadores de los que regala el pack, Shopify parte la linea en
       dos —los que van gratis y los que se cobran— y en el cajon se verian dos
       renglones del mismo producto. Se suman: la cantidad es el total, el
       precio es lo que se cobra, y el tachado la suma de los "antes". */
    var regs = filas.filter(function(f){ return esRegaloKaching(f.it); });
    if(regs.length > 1){
      var base = regs.filter(function(f){ return f.it.final_line_price === 0; })[0] || regs[0];
      var tot=0, pag=0, ant=0, gra=0;
      regs.forEach(function(f){
        tot += f.it.quantity; pag += f.it.final_line_price; ant += antesDe(f.it);
        if(f.it.final_line_price === 0) gra += f.it.quantity;
      });
      base.fusion = { cantidad:tot, precio:pag, antes:ant, gratis:gra };
      filas = filas.filter(function(f){ return !esRegaloKaching(f.it) || f === base; });
    }

    h += '<div class="rz-cart__lista">';
    for(var i=0;i<filas.length;i++){
      var it = filas[i].it, linea = filas[i].linea, fus = filas[i].fusion;
      var variante = (it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : '';
      /* "3 botellas" en vez de "1 Shampoo": ver el comentario de fotoPorCantidad. */
      if(it.variant_id === SHAMPOO_P1) variante = it.quantity + (it.quantity === 1 ? ' botella' : ' botellas');
      var regalo = esRegalo(it);
      var cantReg = fus ? fus.cantidad : it.quantity;
      var gratisReg = fus ? fus.gratis : it.quantity;
      var precioReg = fus ? fus.precio : it.final_line_price;
      var antesReg  = fus ? fus.antes  : antesDe(it);
      if(!fus && esRegaloLanding(it)){ precioReg = 0; antesReg = it.original_line_price; }
      if(regalo) variante = cantReg + (cantReg === 1 ? ' unidad' : ' unidades');
      h += '<div class="rz-cart__item" data-linea="'+linea+'" data-key="'+it.variant_id+'">'
        +   '<span class="rz-cart__foto">'
        +     foto(it)
        +     /* Sin la chapita "x2" sobre la foto: Huel no la tiene y la cantidad
                 ya esta en el selector, dos renglones mas abajo. */
              ''
        +   '</span>'
        +   '<span class="rz-cart__datos">'
        +     '<a class="rz-cart__titulo" href="'+esc(it.url)+'">'+esc(it.product_title.replace('RAIZAL™ - ',''))+'</a>'
        +     (variante ? '<span class="rz-cart__variante">'+esc(variante)+'</span>' : '')
        +     (regalo
                 /* El renglon del regalo lleva EL MISMO selector que el shampoo,
                    y no un boton aparte: era lo que pedia Mark y es la unica
                    forma de cantidad que existe en el cajon.
                    El minimo es lo que viene gratis —abajo de eso no tiene
                    sentido bajar— y lo que se pida de mas Shopify lo cobra. */
                 ? '<span class="rz-cart__regalo-fila">'
                   + '<span class="rz-cart__regalo">Regalo</span>'
                   + (esRegaloLanding(it) ? '' : selector(linea, cantReg, gratisReg, true))
                   + '</span>'
                 : selector(linea, it.quantity, minimoDe(it)))
        +   '</span>'
        +   '<span class="rz-cart__der">'
        +     (regalo ? '' :
                '<button class="rz-cart__borrar" type="button" data-borrar="'+linea+'" aria-label="Quitar '+esc(it.product_title)+'">'
                + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M5 7h14M10 7V5.5A1.5 1.5 0 0 1 11.5 4h1A1.5 1.5 0 0 1 14 5.5V7M6.5 7l.8 11.2A2 2 0 0 0 9.3 20h5.4a2 2 0 0 0 2-1.8L17.5 7"/></svg>'
                + '</button>')
        +     '<span class="rz-cart__precio">'
        +       (antesReg > precioReg
                  ? '<s>'+plata(antesReg)+'</s> ' : '')
        +       plata(precioReg)
        +     '</span>'
        +   '</span>'
        + '</div>';
    }
    h += '</div>';

    h += sugeridos(c);
    h += totales(c);

    /* REPINTADO SUAVE (Mark 12/10): si el carrito ya estaba dibujado, las filas que ya
       estaban NO vuelven a entrar (antes se re-animaban todas y parecia que la lista se
       rehacia de golpe). Solo la fila nueva entra abriendose de alto, y las tarjetas de
       "Va bien con tu carrito" y los totales cambian con un fundido corto. */
    var previas = {}, yaHabia = !!cuerpo.querySelector('.rz-cart__lista');
    [].forEach.call(cuerpo.querySelectorAll('.rz-cart__item[data-key]'), function(e){ previas[e.getAttribute('data-key')] = 1; });
    var sugAntes = [].map.call(cuerpo.querySelectorAll('[data-sumar]'), function(b){ return b.getAttribute('data-sumar'); }).join(',');
    cuerpo.innerHTML = h;
    var nuevas = cuerpo.querySelectorAll('.rz-cart__item');
    if(!yaHabia){
      /* Primera vez: entrada escalonada, 40ms entre fila y fila. */
      for(var n=0;n<nuevas.length;n++) nuevas[n].style.animationDelay = (n*40)+'ms';
    } else {
      var lento = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      for(var n2=0;n2<nuevas.length;n2++){
        var fl = nuevas[n2];
        fl.style.animation = 'none';
        if(!previas[fl.getAttribute('data-key')] && !lento && fl.animate){
          var alto = fl.offsetHeight, cs = getComputedStyle(fl);
          fl.style.overflow = 'hidden';
          var an = fl.animate([
            { height:'0px', paddingTop:'0px', paddingBottom:'0px', opacity:0, transform:'translateY(-6px)' },
            { height:alto+'px', paddingTop:cs.paddingTop, paddingBottom:cs.paddingBottom, opacity:1, transform:'none' }
          ], { duration:380, easing:'cubic-bezier(.33,0,.2,1)' });
          an.onfinish = (function(e){ return function(){ e.style.overflow = ''; }; })(fl);
        }
      }
      var sugAhora = [].map.call(cuerpo.querySelectorAll('[data-sumar]'), function(b){ return b.getAttribute('data-sumar'); }).join(',');
      var rielS = cuerpo.querySelector('[data-sug-riel]');
      if(rielS && sugAhora !== sugAntes && !lento && rielS.animate)
        rielS.animate([{opacity:0, transform:'translateX(14px)'},{opacity:1, transform:'none'}], { duration:360, easing:'cubic-bezier(.33,0,.2,1)' });
      var tots = cuerpo.querySelector('.rz-cart__sug') ? cuerpo.querySelector('.rz-cart__sug').nextElementSibling : null;
      if(tots && !lento && tots.animate) tots.animate([{opacity:.35},{opacity:1}], { duration:320, easing:'ease-out' });
      if(!lento && totalF.animate) totalF.animate([{opacity:.3},{opacity:1}], { duration:320, easing:'ease-out' });
    }

    /* Se pone el ancho final en el cuadro siguiente: asi el navegador ve dos
       valores distintos y anima entre ellos. */
    var relleno = cuerpo.querySelector('.rz-cart__riel > span');
    if(relleno && pctDestino !== null){
      requestAnimationFrame(function(){
        requestAnimationFrame(function(){
          relleno.style.width = pctDestino.toFixed(1)+'%';
          pctAnterior = pctDestino;
        });
      });
    }
    pie.hidden = false;
    totalF.textContent = plata(c.total_price);
    enganchar();
  }

  /* La miniatura del renglon. Primero la foto limpia que corresponde a esa
     variante (cfg.fotos); si esa variante no esta en la lista, la del producto
     en Shopify, pedida a 160 para no bajar una de 1000 para un cuadro de 64. */
  /* La caja de compra manda _min con el tamano del pack. Puede no venir:
     lineas viejas, el acondicionador, el masajeador, o algo agregado desde
     otra pagina. En ese caso el minimo es 1 y el selector se comporta como
     siempre. */
  /* ⚠️ LA MISMA TABLA QUE LA FICHA. El tachado de los packs es un numero
     fijo y no la cuenta unitaria: en la caja de compra esta en el {%- case -%}
     de pdp_compra.liquid, con el porque. Si se cambia alla, se cambia aca.
     Sin esto la ficha dice "$109.970 tachado" y el carrito dice "$119.940"
     sobre exactamente la misma compra.
     Las cantidades que no son pack (4, 5, 7...) caen al numero de Shopify, que
     es la cuenta unitaria de siempre. */
  var ANTES_POR_CANTIDAD = { 2: 7140000, 3: 10997000, 6: 19998000 };
  function antesDe(it){
    if(it.variant_id === SHAMPOO_P1 && ANTES_POR_CANTIDAD[it.quantity])
      return ANTES_POR_CANTIDAD[it.quantity];
    if(COMPARA[it.variant_id] && COMPARA[it.variant_id] > it.original_price)
      return COMPARA[it.variant_id] * it.quantity;
    return it.original_line_price;
  }

  /* UN RENGLON DE REGALO NO SE TOCA. Lo agrega Kaching cuando el pack lo
     incluye, y sale $0. Si le dejamos el selector de cantidad, el que sube de
     3 a 5 se lleva dos acondicionadores cobrados adentro de un renglon que
     dice "Regalo"; y si le dejamos el tacho, lo borra sin querer y no hay
     forma de recuperarlo sin rehacer el pedido.
     Se reconoce por el precio en cero y no por una propiedad de Kaching: si
     mañana cambian el nombre de esa propiedad, un renglon gratis sigue siendo
     un renglon gratis. */
  /* Landing cyber-regalo (Mark 16/10): los acondicionadores que agrega la landing llevan _regalo y los deja en $0 un codigo REGALO1/REGALO2.
     Se dibujan igual que el regalo de Kaching (tachado, $0, chapita) y se van si se toca el shampoo. */
  function esRegaloLanding(it){ return !!((it.properties||{})._regalo); }
  function esRegalo(it){ return it.final_line_price === 0 || esRegaloLanding(it); }
  var ACOND_ID = 47280336044281;
  function landingRegalo(c){ return !!c && (c.attributes||{}).rz_landing === 'regalo'; }
  /* Regalo de la landing por cantidad de shampoo: 2 → 1 acond, 3 a 5 → 2. Con 6 o más manda Kaching. */
  function regaloLandingDe(q){ if(q < 2 || q >= 6) return null; return q >= 3 ? [2,'2-ACONDICIONADORES-GRATIS'] : [1,'ACONDICIONADOR-GRATIS']; }
  /* Despues de agregar algo: ¿faltan regalos? (Kaching a veces no los engancha si el envio no vino de un click,
     y los de la landing los pone este archivo). Solo mira faltantes: no toca acondicionadores pagados de mas. */
  function faltanRegalos(c){
    var p=null, kg=0, lg=0;
    for(var i=0;i<c.items.length;i++){ var it=c.items[i];
      if(esRegaloKaching(it)){ if(it.final_line_price===0) kg+=it.quantity; }
      else if(esRegaloLanding(it)) lg+=it.quantity;
      else if(it.variant_id===SHAMPOO_P1) p=it; }
    if(!p) return lg>0;
    var lk=regalosDe(p.quantity), ek=0; if(lk) for(var j=0;j<lk.length;j++) ek+=lk[j].cantidad;
    var r = landingRegalo(c) ? regaloLandingDe(p.quantity) : null, el = r ? r[0] : 0;
    return kg < ek || lg !== el;
  }

  function minimoDe(it){
    var pr = it.properties || {};
    var m = parseInt(pr._min, 10);
    return (m > 1) ? m : 1;
  }

  /* ⚠️ LA FOTO Y LA ETIQUETA DEL SHAMPOO SE ELIGEN POR CANTIDAD, no por
     variante. Desde que la ficha manda el SKU de 1 con la cantidad del pack,
     TODAS las lineas de shampoo son la misma variante: sin esto, el que compra
     el tratamiento de 3 meses ve la foto de una botella sola y la etiqueta
     "1 Shampoo" al lado de un 3, que es justo la confusion que veniamos a
     sacar. */
  var SHAMPOO_P1 = 46625092632825;
  /* Las cuatro fotos estan tomadas en el mismo set y con el frasco centrado y
     del mismo alto, asi que al cambiar de cantidad la tarjeta no pega ningun
     salto. La de dos se genero el 20/09 y hubo que correrla: venia con los
     frascos 7,7% a la derecha. */
  var FOTO_DOS = 'https://cdn.shopify.com/s/files/1/0758/8868/9401/files/2026-09-20_23.22.26.jpg?v=1789957355';
  function fotoPorCantidad(q){
    var f = cfg.fotos || {};
    if(q >= 6) return f['46625092698361'] || null;   /* la de seis */
    if(q >= 3) return f['46625092665593'] || null;   /* la de tres */
    if(q === 2) return FOTO_DOS;                     /* la de dos */
    return f[SHAMPOO_P1] || null;                    /* una botella */
  }

  /* EL MISMO SPINNER QUE EL RESTO DE LA CASA (pedido de Mark, 20/09).
     El boton de agregar un sugerido tenia un anillo girando hecho con
     border-top-color, que es el spinner que sale por defecto en cualquier
     lado. El de la casa es el de Huel: doce rayitas que se encienden de a una
     con steps(12), y es el que ya usan el CTA de la caja de compra y el boton
     de pagar. Se dibuja aca una sola vez y se reusa. */
  var SPINNER = (function(){
    var r='';
    for(var i=0;i<12;i++){
      var op = Math.round((i+1)*100/12);
      r += '<rect x="11.1" y="1.6" width="1.8" height="5.4" rx=".9" opacity="0.'+op+'" transform="rotate('+(i*30)+' 12 12)"/>';
    }
    return '<svg viewBox="0 0 24 24" fill="currentColor">'+r+'</svg>';
  })();

  function foto(it){
    var url = (it.variant_id === SHAMPOO_P1) ? fotoPorCantidad(it.quantity) : null;
    if(!url) url = (cfg.fotos && cfg.fotos[it.variant_id]) || null;
    if(!url && it.image) url = it.image.replace(/(\.[a-z]+)(\?|$)/i,'_160x$1$2');
    if(!url) return '';
    return '<img src="'+esc(url)+'" alt="" loading="lazy">';
  }

  /* Selector de cantidad propio, no el <select> nativo. Con el nativo la lista
     que se abre la dibuja el sistema operativo: ni el alto de fila, ni el radio,
     ni el tilde del elegido se pueden tocar, y quedaba como una pieza pegada de
     otro sitio. Este es un boton + un panel, con los mismos roles de
     accesibilidad que un desplegable de verdad. */
  /* `min` es de donde NO se puede bajar. Viaja en la propiedad _min de la
     linea, que la pone la caja de compra con el tamano del pack elegido: si
     alguien eligio el tratamiento de 3 meses, el carrito no le ofrece 1 ni 2.
     Para sacarlo del carrito esta el tacho, que sigue funcionando: la idea es
     que no se DESARME el pack sin querer, no atraparlo adentro. */
  function selector(linea, cant, min, esRegalo){
    min = Math.max(1, min|0 || 1);
    /* Hasta 12: un año de tratamiento. Pedido de Mark el 25/09, antes llegaba
       a 10. Si la linea ya trae mas, manda la linea. */
    var max = Math.max(cant, min, 12);
    var o = '';
    for(var q=min;q<=max;q++){
      o += '<li role="option" class="rz-cart__opcion'+(q===cant?' esta-elegida':'')+'"'
        +  ' aria-selected="'+(q===cant?'true':'false')+'" data-linea="'+linea+'" data-cant="'+q+'">'
        +  '<span>'+q+'</span>'
        +  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>'
        +  '</li>';
    }
    return '<div class="rz-cart__qty" data-linea="'+linea+'"'+(esRegalo?' data-regalo="1"':'')+'>'
      +   '<button type="button" class="rz-cart__cant" aria-haspopup="listbox" aria-expanded="false" aria-label="Cantidad">'
      +     '<span>'+cant+'</span>'
      +     '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>'
      +   '</button>'
      +   '<ul class="rz-cart__lista-qty" role="listbox" hidden>'+o+'</ul>'
      + '</div>';
  }

  /* ---------- barra de metas ----------
     Calcada de la de Huel. Soporta N metas, no una sola:
       cfg.metas = [{ monto: 45000, etiqueta: "Envío gratis", corto: "GRATIS",
                      falta: "Te faltan {X} para el envío gratis",
                      logro: "Tenés el envío gratis" }, ...]
     Arriba van los carteles —el de la proxima meta en dorado, los ya logrados
     en hueso— y abajo el riel con una pastilla por meta, ubicada en el % que le
     corresponde sobre el monto de la ULTIMA meta.
     Si cfg.metas viene vacio, no se dibuja nada: los montos los define la marca,
     no se inventan. */
  /* Un icono por tipo de meta. El camion para el envio y el % para el descuento:
     con el camion en las dos, la segunda meta parecia otra cosa de envio. */
  function icono(tipo){
    /* El logro NO va con tilde. Un tilde dice "dato correcto", no "lo lograste".
       Huel usa un matasuegras y es lo que hace que la fila se sienta un premio.
       Mismo trazo (1.7, puntas redondas) que los otros dos iconos. */
    if(tipo === 'logro'){
      return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'
        + '<path d="M5.8 11.3 2 22l10.7-3.79"/>'
        + '<path d="M11 13c1.93 1.93 2.83 4.17 2 5-.83.83-3.07-.07-5-2-1.93-1.93-2.83-4.17-2-5 .83-.83 3.07.07 5 2Z"/>'
        + '<path d="m22 2-2.24.75a2.9 2.9 0 0 0-1.96 3.12c.1.86-.57 1.63-1.45 1.63h-.38c-.86 0-1.6.6-1.76 1.44L14 10"/>'
        + '<path d="m22 13-.82-.33c-.86-.34-1.82.2-1.98 1.11-.11.7-.72 1.22-1.43 1.22H17"/>'
        + '<path d="m11 2 .33.82c.34.86-.2 1.82-1.11 1.98C9.52 4.9 9 5.52 9 6.23V7"/>'
        + '<path d="M4 3h.01"/><path d="M22 8h.01"/><path d="M15 2h.01"/><path d="M22 20h.01"/>'
        + '</svg>';
    }
    if(tipo === 'desc'){
      /* El borde NO es un circulo liso: es una roseta de 12 festones, como el de
         Huel. El contorno esta calculado, no dibujado a ojo: 12 puntos sobre un
         circulo de radio 9.3 y entre punto y punto un arco de radio 2.77 hacia
         afuera (1.15 veces la media cuerda). Con 1.0 salen semicirculos y los
         bultos quedan demasiado profundos; con 1.3 se aplastan. El radio 9.3
         sale de comparar la mancha de tinta contra la altura de mayuscula del
         texto de al lado, que es lo unico comparable entre dos capturas de
         escalas distintas: en la de ellos el icono mide 1,8 mayusculas y el
         nuestro daba 1,5. Los puntos del % van con radio 1.55 y no 0.9 para que
         se vean como anillos: con 0.9 el trazo de 1.7 los tapa y quedan macizos. */
      return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'
        + '<path d="M12.00 2.70 A2.77 2.77 0 0 1 16.65 3.95 A2.77 2.77 0 0 1 20.05 7.35 A2.77 2.77 0 0 1 21.30 12.00 A2.77 2.77 0 0 1 20.05 16.65 A2.77 2.77 0 0 1 16.65 20.05 A2.77 2.77 0 0 1 12.00 21.30 A2.77 2.77 0 0 1 7.35 20.05 A2.77 2.77 0 0 1 3.95 16.65 A2.77 2.77 0 0 1 2.70 12.00 A2.77 2.77 0 0 1 3.95 7.35 A2.77 2.77 0 0 1 7.35 3.95 A2.77 2.77 0 0 1 12.00 2.70Z"/>'
        + '<path d="m15.5 8.5-7 7"/><circle cx="8.8" cy="8.8" r="1.55"/><circle cx="15.2" cy="15.2" r="1.55"/>'
        + '</svg>';
    }
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M1 3h13v13H1z"/><path d="M14 8h4l3 3v5h-7z"/><circle cx="5.5" cy="18.5" r="2"/><circle cx="17.5" cy="18.5" r="2"/></svg>';
  }

  var pctAnterior = null, pctDestino = null;
  /* Cuantas metas estaban logradas en el dibujo ANTERIOR. El carrito se rehace
     entero en cada cambio, asi que sin esto no hay forma de saber si una meta
     recien se consiguio o ya venia conseguida. Arranca en null: la primera vez
     (abrir el carrito con cosas adentro) no festeja nada, que seria festejar
     algo que el que compra hizo en otra visita. */
  var logradasAntes = null;
  /* Los valores del bloque de totales en el dibujo anterior, para saber cual
     cambio. Mismo problema que las metas: el carrito se rehace entero y sin
     esto todos los numeros son "nuevos" en cada render. */
  var totalesAntes = null;

  /* Las chispas del festejo. Van en el HTML porque el carrito se redibuja
     entero: si las creara aparte, el siguiente render las borraria.
     Cada una lleva su desvio, su giro y su color en variables CSS; el arco de
     subida y caida lo hace el keyframe. */
  function chispas(){
    var d = [
      [ 16,-20, 160,'#C9A15C'], [ -13,-18, -140,'#215C36'], [ 24,-9,  200,'#E7D3AC'],
      [ -21,-7, -190,'#C9A15C'], [ 7,-26,  110,'#215C36'],  [ -5,-24, -120,'#E7D3AC'],
      [ 29,-17, 230,'#215C36'], [ -27,-16,-210,'#C9A15C']
    ], h = '<span class="rz-cart__chispas" aria-hidden="true">';
    for(var i=0;i<d.length;i++){
      h += '<i style="--dx:'+d[i][0]+'px;--dy:'+d[i][1]+'px;--rot:'+d[i][2]+'deg;'
        +  '--c:'+d[i][3]+';animation-delay:'+(120+i*22)+'ms"></i>';
    }
    return h+'</span>';
  }

  function barraEnvio(total){
    var metas = (cfg.metas || []).slice().sort(function(a,b){ return a.monto - b.monto; });
    if(!metas.length) return '';
    var tope = metas[metas.length-1].monto;
    if(!tope) return '';

    /* Con el cupon de envio puesto, la meta del envio ya esta lograda aunque
       no se llegue al monto: si no, la barra le pide plata a alguien que ya lo
       tiene. Las demas metas siguen midiendose por monto. */
    var conEnvio = !!envioPorCupon();
    var logradas = 0, proxima = null;
    for(var i=0;i<metas.length;i++){
      var ok = (total >= metas[i].monto) || (conEnvio && metas[i].icono === 'envio');
      if(ok) logradas++;
      else if(!proxima) proxima = metas[i];
    }

    /* Carteles: primero el pendiente (dorado), despues los logrados (hueso).
       Es el orden de Huel: lo que falta arriba, lo conseguido abajo. */
    var carteles = '';
    if(proxima){
      var falta = proxima.monto - total;
      carteles += '<p class="rz-cart__meta rz-cart__meta--falta">'
        + icono(proxima.icono)
        + '<span>'+ (proxima.falta || 'Te faltan {X}').replace('{X}','<b>'+plata(falta)+'</b>') +'</span></p>';
    }
    for(var k=0;k<metas.length;k++){
      if(total < metas[k].monto && !(conEnvio && metas[k].icono === 'envio')) continue;
      /* Recien lograda = esta dentro de las logradas de ahora pero fuera de las
         que habia antes. Las metas van ordenadas por monto, asi que alcanza con
         comparar el indice contra el contador anterior. */
      var recien = (logradasAntes !== null && k >= logradasAntes);
      carteles += '<p class="rz-cart__meta rz-cart__meta--ok'+(recien?' recien':'')+'">'
        + icono('logro')
        + '<span>'+ esc(metas[k].logro || metas[k].etiqueta) +'</span>'
        + (recien ? chispas() : '')
        + '</p>';
    }

    /* Pastillas y etiquetas, cada una en el % que ocupa su monto sobre el tope. */
    var pastillas = '', pies = '';
    for(var j=0;j<metas.length;j++){
      var pos = Math.max(0, Math.min(100, metas[j].monto / tope * 100));
      var on = (total >= metas[j].monto) || (conEnvio && metas[j].icono === 'envio');
      /* La ultima meta cae en el 100% y la primera puede caer en el 0: centradas
         con translateX(-50%) se salen media pastilla del cajon. En los extremos
         se pegan al borde en vez de centrarse. */
      var estilo;
      if(pos >= 97) estilo = 'right:0;left:auto;transform:none';
      else if(pos <= 3) estilo = 'left:0;transform:none';
      else estilo = 'left:'+pos.toFixed(1)+'%';
      var recienPast = on && logradasAntes !== null && j >= logradasAntes;
      pastillas += '<span class="rz-cart__pastilla'+(on?' esta-on':'')+(recienPast?' recien':'')+'" style="'+estilo+'">'
                +  esc(metas[j].corto || metas[j].etiqueta) + '</span>';
      pies += '<span class="rz-cart__hito" style="'+estilo+'">'+plata(metas[j].monto)+'</span>';
    }

    var pct = Math.max(0, Math.min(100, total / tope * 100));
    var todo = logradas === metas.length;

    /* El carrito se vuelve a dibujar entero en cada cambio, asi que la barra
       nacia ya en su ancho final y la transicion nunca se veia. Se dibuja con
       el ancho ANTERIOR y despues de insertarla se le pone el nuevo: ahi si
       corre el transition del CSS. */
    var desde = (pctAnterior === null) ? pct : pctAnterior;
    pctDestino = pct;
    var festeja = (logradasAntes !== null && logradas > logradasAntes);
    logradasAntes = logradas;

    return '<div class="rz-cart__envio'+(todo?' esta-completo':'')+(festeja?' festeja':'')+'">'
         + carteles
         + '<div class="rz-cart__progreso">'
         +   '<div class="rz-cart__pastillas">'+pastillas+'</div>'
         +   '<div class="rz-cart__riel"><span style="width:'+desde.toFixed(1)+'%"></span></div>'
         +   '<div class="rz-cart__hitos">'+pies+'</div>'
         + '</div></div>';
  }

  function sugeridos(c){
    var lista = cfg.sugeridos || [];
    if(!lista.length) return '';
    var dentro = {};
    for(var i=0;i<c.items.length;i++) dentro[c.items[i].variant_id] = true;
    /* Con un pack ya en el carrito no se sugiere otro pack encima (Mark 12/10). */
    var hayPack = false;
    for(var j=0;j<c.items.length;j++) if(String(c.items[j].handle||'').indexOf('pack-')===0) hayPack = true;
    var libres = lista.filter(function(p){ return !dentro[p.id] && !(hayPack && String(p.url||'').indexOf('/products/pack-')===0); });
    if(!libres.length) return '';
    /* Carrusel, como el de Huel: una tarjeta por vez y la siguiente asomando por
       la derecha, con las dos flechas arriba a la derecha. Las flechas aparecen
       solo si hay mas de una tarjeta — con una sola serian dos botones que no
       hacen nada. */
    var flechas = libres.length > 1
      ? '<span class="rz-cart__sug-flechas">'
        + '<button class="rz-cart__sug-fl" type="button" data-sug="-1" aria-label="Anterior" disabled>'
        +   '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="m14 6-6 6 6 6"/></svg>'
        + '</button>'
        + '<button class="rz-cart__sug-fl" type="button" data-sug="1" aria-label="Siguiente">'
        +   '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="m10 6 6 6-6 6"/></svg>'
        + '</button></span>'
      : '';

    var h = '<div class="rz-cart__sug">'
          + '<div class="rz-cart__sug-tapa"><h3>Va bien con tu carrito</h3>'+flechas+'</div>'
          + '<div class="rz-cart__sug-riel" data-sug-riel>';
    for(var k=0;k<libres.length;k++){
      var p = libres[k];
      h += '<div class="rz-cart__sug-item">'
        +   '<span class="rz-cart__sug-viz"><img src="'+esc(p.img)+'" alt="" loading="lazy"></span>'
        +   '<span class="rz-cart__sug-txt">'
        +     (p.bajada ? '<span class="rz-cart__sug-bajada">'+esc(p.bajada)+'</span>' : '')
        +     '<b>'+esc(p.titulo)+'</b>'
        +     '<span class="rz-cart__sug-pie">'
        +       '<span class="rz-cart__sug-precios">'+(p.antes > p.precio ? '<s class="rz-cart__sug-antes">'+plata(p.antes)+'</s>' : '')+'<span class="rz-cart__sug-precio">'+plata(p.precio)+'</span></span>'
        +       '<button class="rz-cart__sumar" type="button" data-sumar="'+p.id+'">'
        +         '<span class="rz-cart__sumar-txt">Agregar</span>'
        +         '<span class="rz-cart__sumar-spin" aria-hidden="true">'+SPINNER+'</span>'
        +       '</button>'
        +     '</span>'
        +   '</span>'
        + '</div>';
    }
    return h + '</div></div>';
  }

  /* ---------- los cupones que entraron por link ----------
     Desde que BIENVENIDA10 es descuento de PEDIDO, Shopify lo publica en
     `cart_level_discount_applications` con su valor, asi que el nombre y el
     "10% OFF" de la derecha salen de ahi y no hay que adivinar nada.

     El de envio es la excepcion: un descuento de envio NO viaja en el carrito
     porque el envio todavia no existe. Ese lo avisa el pop-up dejando una
     marca al tocar el boton final, y solo se toma por buena mientras la sesion
     siga teniendo un codigo puesto: si se perdio la cookie, se perdieron los
     dos codigos. */
  var CUPON_ENVIO = 'ENVIOGRATIS';
  function envioPorCupon(){
    try{
      /* La via principal es la cookie: el pop-up pone el codigo de envio
         ULTIMO en la cadena justamente para que quede ahi. Asi funciona venga
         de donde venga —pop-up, mail, un link pegado a mano— y no depende de
         que alguien haya tocado un boton en este navegador. */
      var m = document.cookie.match(/(?:^|;\s*)discount_code=([^;]+)/);
      if(m && decodeURIComponent(m[1]).toUpperCase() === CUPON_ENVIO) return CUPON_ENVIO;
      /* Y por las dudas, la marca que deja el boton del pop-up, por si despues
         se aplico otro codigo y la cookie quedo pisada. Solo vale mientras
         siga habiendo algun codigo en la sesion. */
      if(!m) return '';
      var v = localStorage.getItem('rzjg_envio');
      return (v && Date.now() < parseInt(v, 10)) ? CUPON_ENVIO : '';
    }catch(e){ return ''; }
  }

  /* El umbral del envio sale de la misma meta que dibuja la barra, no de un
     numero escrito aca: los dos lugares no pueden decir cosas distintas. */
  function metaEnvio(){
    var ms = cfg.metas || [];
    for(var i=0;i<ms.length;i++) if(ms[i].icono === 'envio') return ms[i];
    return null;
  }

  function cupones(c){
    var lista = [], ap = c.cart_level_discount_applications || [], i;
    for(i=0;i<ap.length;i++){
      var a = ap[i];
      var pct = a.value_type === 'percentage' ? Math.round(parseFloat(a.value)) + '% OFF' : null;
      if(a.type === 'discount_code'){
        /* El cupon se nombra por su codigo, que es lo que la persona escribio
           o recibio, y a la derecha va lo que da. */
        lista.push([String(a.title).replace(/[<>&"]/g,''),
                    pct || plata(a.total_allocated_amount), true,
                    a.total_allocated_amount || 0]);
      }else{
        /* El automatico no tiene codigo que mostrar: se nombra por lo que es
           —"10% OFF"— y a la derecha va la plata que descuenta, que es el dato
           que la barra de arriba no da. */
        lista.push([pct || 'DESCUENTO', '−' + plata(a.total_allocated_amount), false,
                    a.total_allocated_amount || 0]);
      }
    }
    var env = envioPorCupon();
    if(env){
      lista.push([env, 'Envío gratis', true, 0]);
    }else{
      /* Y el envio ganado por monto tambien es una chapita: es lo mismo que
         conseguir el cupon, solo que llegando al umbral. */
      var m = metaEnvio();
      var baseEnv = c.items_subtotal_price || c.total_price;
      if(m && baseEnv >= m.monto) lista.push(['ENVÍO GRATIS', 'Incluido', false, 0]);
    }
    return lista;
  }

  function totales(c){
    /* ⚠️ EL SUBTOTAL ES LO QUE CUESTAN LOS RENGLONES, NO LA SUMA DE LOS
       TACHADOS. Antes sumaba los "antes" y el resumen quedaba con cuatro
       numeros grandes encadenados —subtotal $635.700, descuentos $455.718,
       otro descuento, y total $179.982— que es lo que Mark llamo "muchos
       numeros y confunden". El ahorro del pack ya se ve en el renglon, tachado.

       Y el renglon "Descuentos" queda SOLO para lo que no tenga su propia
       chapita: si el unico descuento es el 10% o el cupon, el numero ya esta
       ahi abajo y repetirlo arriba es contarlo dos veces. */
    var bruto = c.items_subtotal_price;
    if(!bruto){ bruto = 0; for(var b=0;b<c.items.length;b++) bruto += c.items[b].final_line_price; }
    for(var bl=0;bl<c.items.length;bl++) if(esRegaloLanding(c.items[bl])) bruto -= c.items[bl].final_line_price;
    var cups = cupones(c).filter(function(x){ return !/ACONDICIONADOR/i.test(x[0]); }), ci;
    var enChapitas = 0;
    for(ci=0; ci<cups.length; ci++) enChapitas += (cups[ci][3] || 0);
    var rebaja = Math.max(0, bruto - c.total_price - enChapitas);

    /* Los renglones se arman como datos y no como HTML pegado, porque hay que
       compararlos contra los del dibujo anterior antes de escribirlos. */
    var filas = [ ['sub','Subtotal:', plata(bruto), false] ];
    /* "Descuentos:" es el encabezado de las chapitas, no un renglon con su
       propio numero: el numero ya esta en cada chapita. Solo lleva importe si
       quedo algo suelto que no tenga chapita. */
    if(rebaja || cups.length) filas.push(['desc','Descuentos:', rebaja ? '−'+plata(rebaja) : '', false]);
    /* Cada cupon es un renglon mas del resumen: la chapita a la izquierda,
       donde van las etiquetas, y lo que da a la derecha, donde van los
       numeros. Colgados del renglon de Descuentos, que es de lo que hablan. */
    for(ci=0; ci<cups.length; ci++){
      filas.push(['cup'+ci,
        '<span class="rz-cart__cupon">' + cups[ci][0]
        + (cups[ci][2]
            ? '<button class="rz-cart__cupon-x" type="button" data-rz-cupon-x'
              + ' aria-label="Quitar el cupón">'
              + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8"'
              +   ' stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>'
              + '</button>'
            : '')
        + '</span>',
        cups[ci][1], false, ci === 0 ? 1 : 2]);
    }
    filas.push(['env','Envío:', envio(bruto, cups), false]);
    filas.push(['tot','Total:', plata(c.total_price), true]);

    var ahora = {}, h = '<div class="rz-cart__totales">', i;
    for(i=0;i<filas.length;i++){
      var cla = filas[i][0], et = filas[i][1], val = filas[i][2], fuerte = filas[i][3],
          esCupon = filas[i][4];
      ahora[cla] = val;
      /* Tres estados posibles contra el dibujo anterior: el renglon es nuevo
         (se abre), el valor cambio (se recambia solo el numero), o no paso nada. */
      var nueva  = (totalesAntes !== null && !(cla in totalesAntes));
      var cambio = (totalesAntes !== null && (cla in totalesAntes) && totalesAntes[cla] !== val);
      h += '<div class="rz-cart__filaw'+(fuerte?' rz-cart__filaw--fuerte':'')
        +      (esCupon?' rz-cart__filaw--cupon':'')+(nueva?' entra':'')+'">'
        +    '<div class="rz-cart__fila'+(fuerte?' rz-cart__fila--fuerte':'')
        +      (esCupon===1?' rz-cart__fila--cupon1':'')+'">'
        +      '<span>'+et+'</span>'
        +      '<span'+(cambio?' class="cambia"':'')+'>'+val+'</span>'
        +    '</div></div>';
      /* La chapita del cupon cuelga del renglon de Descuentos, que es de lo
         que habla. Si no hay descuentos todavia, va antes del Total. */
    }
    /* Un renglon que DEJO de estar (se cayo el descuento) se dibuja igual, con
       su valor viejo y marcado para cerrarse. Sin esto desaparece de golpe,
       que es justo lo que se queria sacar. No entra en `ahora`, asi que en el
       dibujo siguiente ya no se emite. */
    if(totalesAntes){
      for(var cl in totalesAntes){
        if(ahora[cl] !== undefined) continue;
        h += '<div class="rz-cart__filaw sale"><div class="rz-cart__fila">'
          +    '<span>'+(cl === 'desc' ? 'Descuentos:' : '')+'</span>'
          +    '<span>'+totalesAntes[cl]+'</span>'
          +  '</div></div>';
      }
    }
    totalesAntes = ahora;

    return h
      + '<p class="rz-cart__nota">Los descuentos se aplican en el checkout.</p>'
      + pagos()
      + '<button class="rz-cart__seguir" type="button" data-rz-cart-cerrar>Seguir comprando</button>'
      + '</div>';
  }

  /* El renglon de envio responde a lo que hay en el carrito, igual que el
     "Shipping FREE" de Huel. El umbral NO se escribe aca: se lee de la misma
     meta que dibuja la barra de arriba (la que tiene icono "envio"), asi los
     dos lugares no pueden decir cosas distintas.
     OJO, esto PROMETE: que el envio salga realmente gratis a partir de ese
     monto depende de la tarifa configurada en Shopify. */
  function envio(total, cups){
    /* El cupon de envio gana sobre el monto: el suscriptor lo tiene desde el
       primer peso. Sin cupon vale el umbral de la barra, como antes. */
    if(cups) for(var k=0;k<cups.length;k++) if(cups[k][1] === 'Envío gratis') return '<b>GRATIS</b>';
    var ms = cfg.metas || [], m = null;
    for(var i=0;i<ms.length;i++) if(ms[i].icono === 'envio') m = ms[i];
    if(m && total >= m.monto) return '<b>GRATIS</b>';
    return 'Se calcula en el checkout';
  }

  /* Los medios de pago debajo de los totales, como Huel. Vienen de Liquid en
     cfg.pagos porque este bloque se dibuja en el navegador. */
  function pagos(){
    var l = cfg.pagos || [];
    if(!l.length) return '';
    var h = '<div class="rz-cart__pagos">';
    for(var i=0;i<l.length;i++){
      h += '<img src="'+esc(l[i].src)+'" alt="'+esc(l[i].alt)+'" width="38" height="24" loading="lazy">';
    }
    return h + '</div>';
  }

  function vacio(){
    /* Carrito vacio: no hay totales. Se resetea el estado para que volver a
       cargar algo sea un primer dibujo y no anime todo de una. */
    totalesAntes = null;
    /* Dos flechas, como en el resto del sitio: una sale y la otra entra. */
    var flecha = '<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 8h11M9 4l4 4-4 4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    var tarjetas = (cfg.vacio||[]).map(function(p){
      return '<a class="rz-cart__tarjeta" href="'+esc(p.url)+'">'
           +   '<b>'+esc(p.titulo)+'</b>'
           +   (p.img ? '<img src="'+esc(p.img)+'" alt="" loading="lazy">' : '')
           +   '<em><span class="rz-flecha-1">'+flecha+'</span><span class="rz-flecha-2">'+flecha+'</span></em>'
           + '</a>';
    }).join('');
    var html = '<div class="rz-cart__vacio">'
      + '<h3>Tu carrito está vacío</h3>'
      + '<a class="rz-cart__todo" href="/collections/all">Ver todo</a>'
      + (tarjetas ? '<div class="rz-cart__grilla">'+tarjetas+'</div>' : '')
      + '</div>';
    /* PASO A VACIO SUAVE (Mark 12/10): si habia productos, lo que queda (barra, sugeridos,
       totales) se desvanece subiendo apenas, el pie de pago baja y se va, y recien ahi entra
       el vacio: titulo y tarjetas apareciendo de a una. Antes era un corte seco. */
    var lento = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var habia = !!cuerpo.querySelector('.rz-cart__lista');
    function entrar(){
      cuerpo.innerHTML = html;
      pie.hidden = true;
      loopFlechas();
      if(lento || !cuerpo.animate) return;
      var piezas = cuerpo.querySelectorAll('.rz-cart__vacio > h3, .rz-cart__vacio > .rz-cart__todo, .rz-cart__tarjeta');
      for(var i=0;i<piezas.length;i++){
        piezas[i].animate([{opacity:0, transform:'translateY(10px)'},{opacity:1, transform:'none'}],
          { duration:420, delay:i*60, easing:'cubic-bezier(.2,.8,.2,1)', fill:'backwards' });
      }
    }
    if(!habia || lento || !cuerpo.animate){ entrar(); return; }
    var sale = cuerpo.animate([{opacity:1, transform:'none'},{opacity:0, transform:'translateY(-8px)'}],
      { duration:240, easing:'cubic-bezier(.33,0,.2,1)', fill:'forwards' });
    if(!pie.hidden && pie.animate){
      pie.animate([{opacity:1, transform:'none'},{opacity:0, transform:'translateY(16px)'}],
        { duration:260, easing:'cubic-bezier(.33,0,.2,1)', fill:'forwards' }).onfinish = function(){
          pie.hidden = true; pie.getAnimations && pie.getAnimations().forEach(function(a){ a.cancel(); });
        };
    }
    sale.onfinish = function(){ sale.cancel(); entrar(); };
  }

  /* Mismo loop que las pastillas y las cards del resto del sitio: al entrar el
     mouse la flecha se va para la derecha y entra otra por la izquierda; al
     salir, para el otro lado. El animationend solo cierra con la animacion de
     ENTRADA, que dura mas que la de salida. */
  function loopFlechas(){
    var tt = cuerpo.querySelectorAll('.rz-cart__tarjeta');
    for(var i=0;i<tt.length;i++){(function(c){
      function play(cls){
        c.classList.remove('is-loop','is-loop-rev');
        void c.offsetWidth;
        c.classList.add(cls);
      }
      c.addEventListener('mouseenter',function(){ play('is-loop'); });
      c.addEventListener('mouseleave',function(){ play('is-loop-rev'); });
      c.addEventListener('animationend',function(e){
        if(e.animationName==='rz-cf-in'||e.animationName==='rz-cf-in-rev'){
          c.classList.remove('is-loop','is-loop-rev');
        }
      });
    })(tt[i]);}
  }

  /* ---------- eventos de lo recien pintado ---------- */
  function enganchar(){
    /* Abrir y cerrar el panel de cantidad. Se cierra cualquier otro que este
       abierto: dos paneles a la vez se pisan. */
    var caj = cuerpo.querySelectorAll('.rz-cart__qty');
    for(var i=0;i<caj.length;i++){
      (function(q){
        var btn = q.querySelector('.rz-cart__cant');
        var panel = q.querySelector('.rz-cart__lista-qty');
        btn.addEventListener('click', function(e){
          e.stopPropagation();
          var abierto = !panel.hidden;
          cerrarQty();
          if(!abierto){
            panel.hidden = false;
            q.classList.add('esta-abierto');
            /* La fila tiene que subir por encima de las de abajo. Cada
               .rz-cart__item tiene una animacion de entrada con transform y eso
               le arma su propio contexto de apilado: el panel, aunque tenga
               z-index, queda encerrado adentro de su fila y las de abajo le pasan
               por encima. Por eso el unico que se veia bien era el ultimo. */
            var fila = q.closest('.rz-cart__item');
            if(fila) fila.classList.add('tiene-panel');
            btn.setAttribute('aria-expanded','true');
            var elegida = panel.querySelector('.esta-elegida');
            if(elegida) panel.scrollTop = Math.max(0, elegida.offsetTop - 8);
          }
        });
        panel.addEventListener('click', function(e){
          var li = e.target.closest('.rz-cart__opcion');
          if(!li) return;
          cerrarQty();
          var cant = parseInt(li.getAttribute('data-cant'),10);
          var caja = li.closest('.rz-cart__qty');
          /* El selector del regalo no cambia una linea: fija el TOTAL de
             acondicionadores y deja que Shopify lo parta en gratis y pagos. */
          if(caja && caja.getAttribute('data-regalo')){
            cambiarRegalo(cant, parseInt(caja.getAttribute('data-linea'),10));
          }
          else cambiar(parseInt(li.getAttribute('data-linea'),10), cant);
        });
      })(caj[i]);
    }
    var bor = cuerpo.querySelectorAll('[data-borrar]');
    for(var j=0;j<bor.length;j++){
      bor[j].addEventListener('click', function(){
        cambiar(parseInt(this.getAttribute('data-borrar'),10), 0);
      });
    }
    var mas = cuerpo.querySelectorAll('[data-sumar]');
    for(var k=0;k<mas.length;k++){
      mas[k].addEventListener('click', function(){
        sumar(parseInt(this.getAttribute('data-sumar'),10), this);
      });
    }
    var cx = cuerpo.querySelectorAll('[data-rz-cupon-x]');
    for(var n=0;n<cx.length;n++){
      cx[n].addEventListener('click', function(){
        this.disabled = true;
        quitarCupon();
      });
    }
    var cerrar2 = cuerpo.querySelectorAll('[data-rz-cart-cerrar]');
    for(var m=0;m<cerrar2.length;m++) cerrar2[m].addEventListener('click', cerrar);
    flechasSug();
  }

  /* Las flechas del carrusel de sugeridos. El paso NO es un numero fijo: se mide
     la tarjeta real mas el hueco, asi sigue andando si cambia el ancho del cajon
     o la cantidad de tarjetas. */
  function flechasSug(){
    var riel = cuerpo.querySelector('[data-sug-riel]');
    if(!riel) return;
    var btns = cuerpo.querySelectorAll('[data-sug]');
    if(!btns.length) return;

    function paso(){
      var t = riel.querySelector('.rz-cart__sug-item');
      if(!t) return riel.clientWidth;
      var hueco = parseFloat(getComputedStyle(riel).columnGap) || 0;
      return t.getBoundingClientRect().width + hueco;
    }
    /* Se apagan en los extremos, como las de ellos. El margen de 2px es por el
       redondeo del scroll: sin el, la flecha del final queda encendida por una
       fraccion de pixel y no lleva a ningun lado. */
    function pintar(){
      var fin = riel.scrollWidth - riel.clientWidth;
      for(var i=0;i<btns.length;i++){
        var d = parseInt(btns[i].getAttribute('data-sug'),10);
        btns[i].disabled = d < 0 ? riel.scrollLeft <= 2 : riel.scrollLeft >= fin - 2;
      }
    }
    for(var i=0;i<btns.length;i++){
      (function(b){
        b.addEventListener('click', function(){
          var d = parseInt(b.getAttribute('data-sug'),10);
          riel.scrollBy({ left: d * paso(), behavior:'smooth' });
        });
      })(btns[i]);
    }
    var pedido = false;
    riel.addEventListener('scroll', function(){
      if(pedido) return;
      pedido = true;
      requestAnimationFrame(function(){ pedido = false; pintar(); });
    });
    pintar();
  }

  /* Si alguien agrega algo desde una ficha de producto, el cajon se abre solo. */
  document.addEventListener('submit', function(e){
    var f = e.target;
    if(!f || f.tagName!=='FORM') return;
    if((f.getAttribute('action')||'').indexOf('/cart/add') === -1) return;
    e.preventDefault();
    var datos = new FormData(f);
    /* De que landing viene (Mark 16/10): la de regalo marca su form; cualquier otro agregado borra la marca. */
    fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:{rz_landing:f.getAttribute('data-rz-landing')||''}})}).catch(function(){})
      .then(function(){ return fetch('/cart/add.js',{method:'POST', body:datos, headers:{'Accept':'application/json'}}); })
      /* CYBER: extras elegidos en la ficha (el acondicionador del "Completá tu
         tratamiento") se suman DESPUES del pack, en un segundo pedido, para que
         Kaching resuelva el pack solo. Se abre el cajon una vez, con todo. */
      .then(function(){
        var x = window.RZ_CART_EXTRA; window.RZ_CART_EXTRA = null;
        if(!x || !x.length) return;
        return fetch('/cart/add.js',{method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({items:x})})
          .then(function(){ document.dispatchEvent(new CustomEvent('rz:extra-agregado')); });
      })
      .then(function(){ return fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){ return r.json(); })
        .then(function(c){ return faltanRegalos(c) ? reconciliarRegalos() : null; }).catch(function(){}); })
      .then(function(){ abrir(); })
      .catch(function(){ f.submit(); });
  });
})();


/* El boton de pagar muestra el spinner desde el click hasta que el navegador
   se va al checkout. Es el rato en el que no pasa nada visible y el que compra
   no sabe si el click funciono. Se engancha en el documento porque el pie del
   carrito existe desde el arranque pero el estado se pisa en cada repintado. */
document.addEventListener('click', function(e){
  var b = e.target.closest && e.target.closest('.rz-cart__pagar');
  if(b) b.classList.add('esta-cargando');
});


/* La chapita del header, para cualquiera que cambie el carrito. */
document.addEventListener('rz:carrito', function(e){
  var c = e.detail; if(!c) return;
  var marcas = document.querySelectorAll('[data-rz-cart-count]');
  for(var i=0;i<marcas.length;i++){
    var m = marcas[i];
    var antes = m.textContent;
    m.textContent = c.item_count;
    /* Escondida cuando el carrito esta vacio: un cero colgado del icono se lee
       como un error. */
    m.hidden = !c.item_count;
    /* Si el numero cambio, se reinicia la animacion de aparicion. Sin quitar y
       volver a poner la clase, el navegador no la vuelve a correr. */
    if(antes !== m.textContent && !m.hidden){
      m.style.animation='none';
      void m.offsetWidth;
      m.style.animation='';
    }
  }
});

/* Cerrar el panel de cantidad al tocar afuera o con Escape. Va una sola vez en
   el documento y no por fila, porque el carrito se repinta entero. */
function cerrarQty(){
  var abiertos = document.querySelectorAll('.rz-cart__qty.esta-abierto');
  for(var i=0;i<abiertos.length;i++){
    abiertos[i].classList.remove('esta-abierto');
    abiertos[i].querySelector('.rz-cart__lista-qty').hidden = true;
    abiertos[i].querySelector('.rz-cart__cant').setAttribute('aria-expanded','false');
  }
  var subidas = document.querySelectorAll('.rz-cart__item.tiene-panel');
  for(var j=0;j<subidas.length;j++) subidas[j].classList.remove('tiene-panel');
}
document.addEventListener('click', function(e){
  if(!e.target.closest || !e.target.closest('.rz-cart__qty')) cerrarQty();
});
document.addEventListener('keydown', function(e){
  if(e.key === 'Escape') cerrarQty();
});
